// extracted by mini-css-extract-plugin
export default {"label":"Radio_label__vl0zM","radioContainer":"Radio_radioContainer__zzwwM","radio":"Radio_radio__7XYwx"};